const DEFAULT_LIMIT = 200;
const DEFAULT_OFFSET = 0;

/*
	This module facilitates getting all pages of a list endpoint.
	Bonus points - it's also cancelable
*/
export default function getPagedRequest( {
	request,
	onResponse,
	limit = DEFAULT_LIMIT,
	offset = DEFAULT_OFFSET,
	autoStart = true,
} ) {
	return function pagedRequest( options ) {
		let cancel = false;

		function results( response ) {
			if ( !cancel ) {
				if ( onResponse ) {
					onResponse( response, options );
				}
				if ( limit === response.length ) {
					offset += limit;
					executeRequest();
					return;
				}
			}
		}

		function executeRequest() {
			request( { limit, offset, ...options, } ).then( results );
		}

		if ( autoStart ) {
			executeRequest();
		}

		const currentRequest = {
			cancel() {
				cancel = true;
			},
			start() {
				return executeRequest();
			},
		};

		return currentRequest;
	};
}



// WEBPACK FOOTER //
// ./src/helpers/pagerDuty.js